import { Gift } from "lucide-react";
export default function ScienceOfRelaxedBuying() {
  return <section id="why-it-works" style={{
    backgroundColor: 'rgb(251, 245, 240)',
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'repeat',
    color: 'rgb(42, 45, 43)',
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: '96px',
    paddingBottom: '96px',
    position: 'relative',
    overflow: 'hidden'
  }}>
      <div className="page-container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-12 md:gap-20">
          <div className="w-full md:w-7/12 flex flex-col">
            <p className="mb-4" style={{
            fontSize: '11px',
            fontWeight: 600,
            letterSpacing: '0.12em',
            color: '#C8985C',
            textTransform: 'uppercase',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
          }}>
              THE SCIENCE OF RELAXED BUYING
            </p>

            <h2 className="mb-6" style={{
            color: 'rgb(31, 58, 46)',
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: '48px',
            fontWeight: '400',
            lineHeight: '60px',
            border: '0px solid oklch(0.69 0.04 165 / 0.25)'
          }}>
              The Point of Relaxation Purchase™
            </h2>

            <p className="mb-8" style={{
            color: 'rgba(42, 45, 43, 0.8)',
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: '18px',
            fontWeight: '400',
            lineHeight: '29.25px',
            border: '0px solid oklch(0.69 0.04 165 / 0.25)'
          }}>
              The moment a massage ends, two things happen: deep trust and low resistance. The nervous system is calm. The wallet opens easier. PrepayQR catches that 90-second window when clients feel their best — and buy their next three sessions impulsively.
            </p>

            <div style={{
            borderLeft: '2px solid #C8985C',
            paddingLeft: '14px'
          }}>
              <p className="mb-1.5" style={{
              fontSize: '11px',
              fontWeight: 600,
              letterSpacing: '0.12em',
              color: '#C8985C',
              textTransform: 'uppercase',
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
            }}>
                THE EMOTIONAL TRIGGER
              </p>
              <p style={{
              color: 'rgb(31, 58, 46)',
              fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
              fontSize: '20px',
              fontWeight: '400',
              lineHeight: '28px',
              fontStyle: 'italic',
              border: '0px solid oklch(0.69 0.04 165 / 0.25)'
            }}>
                &ldquo;Gift yourself forward. Right now.&rdquo;
              </p>
            </div>
          </div>

          <div className="w-full md:w-5/12 flex items-center justify-center">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694540/img/relaxed_hand-8v8T9Z8eXw6Fsjsio2Wwuu.webp" alt="Client hand relaxed next to phone showing PrepayQR" className="w-full h-auto" style={{
            borderRadius: '16px',
            boxShadow: '0px 0px 22px rgba(0, 0, 0, 0.10)',
            maxWidth: '440px'
          }} />
          </div>
        </div>
      </div>
    </section>;
}